import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Resdit7421PerformanceReport from '../../components/Resdit7421PerformanceReport';
import {
  getPercentageColumns,
  getNumberColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/Resdit7421PerformanceCarrierSelectors';
import Resdit7421PerformanceCarrierReportMode from './Resdit7421PerformanceCarrierReportMode';

const MODE_TABS = [
  { value: Resdit7421PerformanceCarrierReportMode.percentage, label: '%' },
  { value: Resdit7421PerformanceCarrierReportMode.number, label: '#' },
];

export class Resdit7421PerformanceCarrierContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: Resdit7421PerformanceCarrierReportMode.percentage,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderPercentage() {
    return (
      <Resdit7421PerformanceReport
        reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id}
        columns={this.props.percentageColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={Resdit7421PerformanceCarrierReportMode.percentage}
      />
    );
  }

  renderNumber() {
    return (
      <Resdit7421PerformanceReport
        reportId={ReportDefinitions.RESDIT_74_21_PERFORMANCE_CARRIER_107B.id}
        columns={this.props.numberColumns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={Resdit7421PerformanceCarrierReportMode.number}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case Resdit7421PerformanceCarrierReportMode.percentage:
        return this.renderPercentage();
      case Resdit7421PerformanceCarrierReportMode.number:
        return this.renderNumber();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    percentageColumns: getPercentageColumns(state),
    numberColumns: getNumberColumns(state),
  };
}

Resdit7421PerformanceCarrierContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  percentageColumns: PropTypes.arrayOf(PropTypes.object),
  numberColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(Resdit7421PerformanceCarrierContainer);
